import "./Home.module.css";
import EnTete from "@/reusable_sections/Header";
import HeroPrincipal from "./sections/HeroPrincipal";
import NosServices from "./sections/NosServices";
import PourquoiNousChoisir from "./sections/PourquoiNousChoisir";
import TestimonialsSection from "./sections/TestimonialsSection";
import DemandeDevis from "./sections/DemandeDevis";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EnTete />
      <HeroPrincipal />
      <NosServices />
      <PourquoiNousChoisir />
      <TestimonialsSection />
      <DemandeDevis />
      <Footer />
    </div>;
}